export function request() {
    return {
        type: 'PERMISSIONS_GET_REQUEST'
    };
}

export function error(errors) {
    return {
        type: 'PERMISSIONS_GET_ERROR',
        errors
    };
}

export function finish(permissions) {
    return {
        type: 'PERMISSIONS_GET_FINISH',
        permissions
    };
}
